'use client';

import { useStore } from 'zustand';

import { openPaymentsStore } from '@/store/open-payments/open-payments.store';
import { OpenPayment } from '@/types/open-payment.types';

export interface UseOpenPaymentsResult {
  payments: OpenPayment[];
  count: number;
  isLoading: boolean;
  hasError: boolean;
  isEmpty: boolean;
  hasPayments: boolean;
}

export function useOpenPayments(): UseOpenPaymentsResult {
  const payments = useStore(openPaymentsStore, (state) => state.payments);
  const status = useStore(openPaymentsStore, (state) => state.status);

  return {
    payments,
    count: payments.length,
    isLoading: status === 'idle' || status === 'loading',
    hasError: status === 'error',
    isEmpty: status === 'loaded' && payments.length === 0,
    hasPayments: payments.length > 0,
  };
}
